/**
 * Marks a control drawn over a view: a press, move, wheel, double-click or key
 * starting within it reaches no view tool, whatever view lies beneath.
 */
export const VIEW_INPUT_EXCLUDED_ATTRIBUTE = 'data-view-input-excluded';

export const VIEW_INPUT_EXCLUDED_PROPS = {
    [VIEW_INPUT_EXCLUDED_ATTRIBUTE]: true,
} as const;

export function isExcludedFromViewInput(
    target: EventTarget | null | undefined
): boolean {
    return (
        target instanceof Element &&
        target.closest(`[${VIEW_INPUT_EXCLUDED_ATTRIBUTE}]`) !== null
    );
}
